import { useState, useEffect } from '@wordpress/element';
import { BlockPreview } from '@wordpress/block-editor';
import { IoIosArrowBack } from "react-icons/io";
import { parse } from '@wordpress/blocks';
import TemplateCard from '../components/template-card';
import { getFavorites, toggleFavorite } from '../utils/favorites';
import useInsertPattern from '../hooks/use-insert-pattern';
import { MdFavoriteBorder, MdOutlineFavorite } from 'react-icons/md';
import { __ } from '@wordpress/i18n';

const PagePreview = ({ kit, onBack, onInsertComplete,isProActive,handleUpgradeClick }) => {
	const [favorites, setFavorites] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState(null);
	const [previewBlocks, setPreviewBlocks] = useState([]);
	const [isInserting, setIsInserting] = useState(false);

	const isProAvailable = typeof isProActive === 'boolean';
	const isPremium = kit.premium?.toLowerCase() === 'pro' && isProAvailable && isProActive === false;

	// Combine kit root + its templates
	const allTemplates = [
		{ id: kit.id, title: kit.title, pattern: kit.pattern },
		...(kit.templates || [])
	];

	// Load favorites on mount
	useEffect(() => {
		setSelectedTemplate(allTemplates[0]);
		getFavorites().then(setFavorites);
	}, [kit]);

	// Update preview when template changes
	useEffect(() => {
		if (!selectedTemplate?.pattern) return;
		try {
			const blocks = parse(selectedTemplate.pattern);
			setPreviewBlocks(blocks);
		} catch (e) {
			console.error('Pattern parse failed', e);
			setPreviewBlocks([]);
		}
	}, [selectedTemplate]);

	const insertPattern = useInsertPattern(onInsertComplete);

	const handleInsert = async () => {
		if (!selectedTemplate?.pattern) return;
		setIsInserting(true);
		await insertPattern(selectedTemplate.pattern, kit.premium);
		setIsInserting(false);
	};

	const handleToggleFavorite = async (id) => {
		const updated = await toggleFavorite(id);
		setFavorites(updated);
	};

	return (
		<div className="vayu-kit-preview">
			{/* Header */}
			<div className="vayu-kit-header">
				<div className="vayu-bautton-page-pareview-main">
					<button onClick={onBack} className="vayu-back-button">
						<IoIosArrowBack /> Back
					</button>

					<h2 className="vayu-kit-title">{kit.title} {isPremium && (
						<span className="vayu-pro-badge" onClick={handleUpgradeClick} title="Pro Template">
							PRO
						</span>
					)}</h2>
				</div>

				<h2 style={{marginLeft: '24%'}} className="vayu-kit-title">Other Designs</h2>
				<button className="vayu-fav-btn" onClick={() => handleToggleFavorite(kit.id)}>
					{favorites.includes(kit.id) ? (
						<MdOutlineFavorite size={20} />
					) : (
						<MdFavoriteBorder size={20} />
					)}
					<span>Add to Favorites</span>
				</button>
			</div>

			{/* Body Layout */}
			<div className="vayu-kit-body">
				{/* Left: Preview */}
				<div className="vayu-kit-left">
					{previewBlocks.length > 0 ? (
						<BlockPreview blocks={previewBlocks} __experimentalLayout={{ type: 'default' }} />
					) : (
						<div className="vayu-preview-loader">Loading preview…</div>
					)}
				</div>

				{/* Right: Template List + Actions */}
				<div className="vayu-kit-right">
					<div className="vayu-kit-templates">
						{allTemplates.map((tpl) => (
							<div
								key={tpl.id}
								className={`vayu-kit-template-card ${selectedTemplate?.id === tpl.id ? 'selected' : ''}`}
								onClick={() => setSelectedTemplate(tpl)}
							>
								<TemplateCard
									pattern={tpl.pattern}
									title={tpl.title}
									isFavorite={favorites.includes(tpl.id)}
									onToggleFavorite={() => handleToggleFavorite(tpl.id)}
									onClick={() => {}}
									isProActive={isProActive}
									
								/>
							</div>
						))}
					</div>

					<div className="vayu-kit-actions">
						{kit.preview && (
							<button
								className="vb-btn"
								onClick={() => window.open(kit.preview, '_blank')}
							>
								Live Preview
							</button>
						)}

						<button
							className="vb-btn vb-btn-primary"
							onClick={isPremium ? handleUpgradeClick : handleInsert}
							disabled={isInserting}
						>
						
							{isPremium ? (
								__('Unlock with Pro', 'vayu-blocks')
							) : isInserting ? (
								<>
									<span className="vayu-insert-spinner" />
									{__('Inserting...', 'vayu-blocks')}
								</>
							) : (
								__('Insert', 'vayu-blocks')
							)}
							
						</button>

					</div>
				</div>
			</div>
		</div>
	);
};

export default PagePreview;
